import { useMemo } from 'react';
import { useTranslate } from '@tolgee/react';
import { useOrgConfigStateValue } from 'hooks/business/useOrgConfig';
import { Space, Tooltip } from 'antd';
import CheckContainer from 'components/CheckContainer';

export interface CurrencyCheckboxProps {
  currencies: General.Currency[];
  value: General.Currency;
  onChange: (value: General.Currency) => void;
  disabled?: boolean;
  /** 币种不可选判断（如该币种不支持连续包月）；返回 true 时置灰并 hover 提示 */
  currencyDisabled?: (value: General.Currency) => boolean;
  /** 币种不可选原因提示（hover 展示） */
  currencyDisabledTip?: React.ReactNode;
}

const CurrencyCheckbox = (props: CurrencyCheckboxProps) => {
  const {
    value: currency,
    currencies,
    onChange,
    disabled,
    currencyDisabled,
    currencyDisabledTip,
  } = props;
  const { t } = useTranslate();
  const { airwallexEnable } = useOrgConfigStateValue();

  const renderCurrencyList = useMemo(() => {
    return currencies.map((value) => {
      const tv = t(`currency.${value}` as string);
      const itemDisabled = disabled || !!currencyDisabled?.(value);
      const item = (
        <CheckContainer
          key={value}
          disabled={itemDisabled}
          style={{ borderRadius: 4 }}
          checked={currency === value}
          onChange={(checked) => {
            if (checked) {
              onChange(value);
            }
          }}
        >
          <Space>
            <span>{tv}</span>
            {tv !== value && <span>({value})</span>}
          </Space>
        </CheckContainer>
      );
      return itemDisabled && currencyDisabledTip ? (
        <Tooltip key={value} title={currencyDisabledTip}>
          {item}
        </Tooltip>
      ) : (
        item
      );
    });
  }, [t, currencies, currency, onChange, disabled, currencyDisabled, currencyDisabledTip]);

  return airwallexEnable ? (
    <div>
      <h4>{t('scene.managementCenter.sellerPlan.subscriptionTab.label.currency')}</h4>
      <div className="flex flex-wrap gap-3">{renderCurrencyList}</div>
    </div>
  ) : null;
};

export default CurrencyCheckbox;
